import { Injectable } from "@angular/core";

@Injectable()
export class KeyboardService {
  private callbacks: { keydown: any[] };
  private disabled: boolean;
  // Callbacks will not fire when the focus is in these element types, this is
  // to allow ordinary keyboard input with form elements.
  private DISABLE_WHEN_FOCUS = ["search", "text", "textarea"];

  constructor() {
    this.callbacks = { keydown: [] };

    document.addEventListener("keydown", this.keydown.bind(this));
  }

  public onKeydown(callback: any) {
    this.callbacks.keydown.push(callback);
    // Return a function to unregister.
    return () => {
      const index = this.callbacks.keydown.indexOf(callback);
      if (index > -1) {
        return this.callbacks.keydown.splice(index, 1);
      }
    };
  }

  public focusElementType() {
    const el = document.activeElement;
    if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
      return el.type;
    }
  }

  public keydown(event: KeyboardEvent) {
    // Disable when typing in normal input elements such as text or textarea,
    // to allow normal input.
    this.disabled =
      this.DISABLE_WHEN_FOCUS.indexOf(this.focusElementType()) >= 0;
    if (this.disabled) {
      return;
    }

    for (const cb of this.callbacks.keydown) {
      cb(event);
    }
  }
}
